var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"o-mid-container"},[_c('div',{attrs:{"id":"content-body"}},[_c('div',{staticClass:"py-5 text-center w-100"},[_c('div',{staticClass:"mx-auto w-xxl w-auto-xs"},[_c('div',{staticClass:"px-3"})])])])])
}]

export { render, staticRenderFns }